import { NavLink } from "react-router-dom";
import styled from "styled-components";
import backimg from "../../img/wp10989489.webp";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  z-index: 8;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const BurgerStyled = styled.div`
  width: 100%;
  height: auto;
  transform: translateY(-100%);
  transition: all var(--transition);
  z-index: 9;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.75),
      rgba(255, 255, 255, 0.75)
    ),
    url(${backimg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0;
  padding: 120px 0 60px;

  &.enter-done {
    transform: translateY(0);
    opacity: 1;
  }

  & .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 40px;

    & .burger-nav {
      flex-direction: column;
      gap: 12px;

      & .active {
        color: var(--accent);
        pointer-events: none;
      }
    }
  }
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const NavLinkStyled = styled(NavLink)`
  color: var(--color);
  text-decoration: none;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;

  &.active {
    color: var(--accent);
  }
`;
